export default __webpack_public_path__ + "4b9300cef54dfdafa80634ad14999262.svg";